export default __webpack_public_path__ + "static/media/instructor.76112ff7.jpg";